import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { components } from "../../../api/generated/survey-svc";

type CompanyDownload = components["schemas"]["AdminExport"];

const initialState = {
  loading: false,
  data: {
    url: "",
  },
};

const dataSlice = createSlice({
  name: "Company/download",
  initialState: initialState,
  reducers: {
    iniDownloadCompanyStore: () => {
      return { ...initialState };
    },
    startDownloadCompany: (state) => {
      state.loading = true;
    },
    sucessDownloadCompany: (state, action: PayloadAction<CompanyDownload>) => {
      state.data = action.payload;
      state.loading = false;
    },
    failDownloadCompany: (state) => {
      state.loading = false;
    },
  },
});

export const {
  iniDownloadCompanyStore,
  failDownloadCompany,
  startDownloadCompany,
  sucessDownloadCompany,
} = dataSlice.actions;

export default dataSlice.reducer;
